import { Injectable } from '@angular/core';
import { CommonService } from "../common.service";
import { UserPreference, DateRangeParam } from '../../models';
import * as moment from 'moment';
import { WidgethelperService } from "../widgethelper.service";
import { AnalyticsService } from "../analytics.service";
import { BaseService } from "./base.service";
import { HospitalPackedParam } from '../../models/HospitalPackedParam';
import {  errorMessages, appSettings } from "../../settings";
import { WidgetParam } from '../../models/DataModels';

@Injectable()
export class HospitalPackedOrdersService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService
  ) {
    super();
  }

  init(widget: any) {
    widget.dataLoaded = false;
    widget.DataTable = null;

    let param = new WidgetParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    if(setting.PickType == 'PostShip' || setting.PickType == null || setting.PickType == '') {
      setting.PickType = appSettings.Last2Weeks;
    }
    
    dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
    dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);

    this._analyticsService.getDates(dateParam).subscribe(data => {
      if (
        data.Start_Date.toString() != "0001-01-01T00:00:00" &&
        data.End_Date.toString() != "0001-01-01T23:59:59.999"
      ) {
        param.StartDate = new Date(data.Start_Date);
        param.EndDate = new Date(data.End_Date);
        let userPref: UserPreference = this._commonService.getUserPreference();
        param.CustomerId = userPref.CustomerId;
        param.FacilityId = userPref.FacilityId;      

        this.GetHospitalShortSummary(widget, param);     
      }
    });
  }
  GetHospitalShortSummary(widget:any,param: WidgetParam) {
    let userPref: UserPreference = this._commonService.getUserPreference();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;

    this._analyticsService.GetHospitalPackedOrderSummary(param).subscribe(
      result => {
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.DataTable = [{
            'columnsMatrix': [
            {DataColumn:'REPORT_DATE',DisplayColumn:'Report Date',Type:'date'},
            {DataColumn:'PACKED_OPLNS_COUNT',DisplayColumn:'Total Packed Orders'},
            {DataColumn:'PACKED_HOSPITAL_OPLNS_COUNT',DisplayColumn:'Packed Hospital Orders'},
            {DataColumn:'HOSPITAL_BUILD_LOSS_COUNT',DisplayColumn:'Hospital Build (Loss)'},
            {DataColumn:'H_LOCATION_COUNT',DisplayColumn:'Current H Location Quantity'},
            {DataColumn:'S_LOCATION_COUNT',DisplayColumn:'Current S Location Quantity'}],
            'rowsMatrix': [],'widgetData':[]
          },
          {
            'columnsMatrix': [
            {DataColumn:'REPORT_DATE',DisplayColumn:'Report Date',Type:'date'},
            {DataColumn:'PICK_SHORT_COUNT',DisplayColumn:'Pick Short Created'},
            {DataColumn:'PICK_SHORT_COUNT_PERCENTAGE',DisplayColumn:'% Pick Short Created'},
            {DataColumn:'PUT_SHORT_COUNT',DisplayColumn:'Put Short Created'},
            {DataColumn:'PUT_SHORT_COUNT_PERCENTAGE',DisplayColumn:'% Put Short Created'},
            {DataColumn:'HOSPITAL_CREATED_COUNT',DisplayColumn:'Hospital Created'},
            {DataColumn:'HOSPITAL_CREATED_COUNT_PERCENTAGE',DisplayColumn:'% Hospital Created'},
            {DataColumn:'BLINDS_COUNT',DisplayColumn:'Blind Count Created'},
            {DataColumn:'HOSPITAL_BLIND_COUNT_PERCENTAGE',DisplayColumn:'% Blind Count Created'}],
            'rowsMatrix': [],'widgetData':[]
          }];

          widget.DataTable[0].widgetData = result;
          widget.DataTable[1].widgetData = result;
        } 
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;
        widget.chartOptions = null;
      },
      err => {
        console.log("GetHospitalShortSummary", err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/hospital-packed-orders.service.ts